import { AsYouType, getCountries, getCountryCallingCode, isValidPhoneNumber, parsePhoneNumberFromString } from "libphonenumber-js";
import { COUNTRY_NAMES, flagEmoji } from "./countries";

let _entries = null;
export function listCountries() {
  if (_entries) return _entries;
  const arr = [];
  const seen = new Set();
  for (const iso2 of getCountries()) {
    if (seen.has(iso2)) continue;
    seen.add(iso2);
    let dial = "";
    try { dial = String(getCountryCallingCode(iso2)); } catch { continue; }
    arr.push({ iso2, name: COUNTRY_NAMES[iso2] || iso2, dialCode: dial, flag: flagEmoji(iso2) });
  }
  arr.sort((a, b) => a.name.localeCompare(b.name));
  _entries = arr;
  return arr;
}
export function findCountry(iso2) { return listCountries().find((c) => c.iso2 === String(iso2).toUpperCase()) || null; }
export function detectCountry(input) {
  if (!input) return null;
  const p = parsePhoneNumberFromString(input.startsWith("+") ? input : `+${input}`);
  return p?.country || null;
}
export function formatAsYouType(country, national) { return new AsYouType(country).input(national); }
export function toE164(country, national) {
  if (!country || !national?.trim()) return null;
  const p = parsePhoneNumberFromString(national, country);
  if (!p?.isValid()) return null;
  return p.number;
}
export function isValidForCountry(country, national) {
  if (!country || !national?.trim()) return false;
  try { return isValidPhoneNumber(national, country); } catch { return false; }
}
export function splitE164(e164) {
  if (!e164) return { country: null, national: "" };
  const p = parsePhoneNumberFromString(e164);
  if (!p) return { country: null, national: e164.replace(/^\+/, "") };
  return { country: p.country || null, national: p.formatNational() };
}
export function maskE164(e164) {
  if (!e164) return "";
  const p = parsePhoneNumberFromString(e164);
  if (!p) return e164;
  const nat = p.nationalNumber;
  if (nat.length <= 4) return `+${p.countryCallingCode} ${"•".repeat(nat.length)}`;
  return `+${p.countryCallingCode} ${"•".repeat(nat.length - 4)}${nat.slice(-4)}`;
}
